import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {getImageProps} from 'app/utilities/ImageProps';

const StatusMessage = ({type, header, message, icon, backgroundColor, context, onClose}) => {
  const imageProps = icon && context ? getImageProps(icon, context) : null;

  const blockStyles = {
    backgroundColor: backgroundColor,
  };

  return (
    <div className="lead-contact-form-block" style={blockStyles}>
      <div className={`status-message status-message-${type}`}>
        <div className="status-message-content">
          {imageProps?.src && (
            <div className="status-icon">
              <Image {...imageProps} />
            </div>
          )}
          {header && <h2 className="status-header">{header}</h2>}
          {message && <p className="status-text">{message}</p>}
          <button type="button" className="status-button" onClick={onClose}>
            סגור
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusMessage;

